import { Map, fromJS, List } from "immutable";
import {
  FETCH_CONVERSATIONS_SUCCESS,
  FETCH_CONVERSATION_SUCCESS,
  ADD_CONVERSATION_SUCCESS,
  ADD_CONVERSATION_FROM_EVENT_STREAM,
  EDIT_CONVERSATION_FROM_EVENT_STREAM,
  EDIT_CONVERSATION_LOADING,
  LEAVE_CONVERSATION_LOADING,
  DELETE_CONVERSATION_USER_FROM_EVENT_STREAM,
  ADD_CONVERSATION_ADMIN_LOADING,
  ADD_CONVERSATION_ADMIN_SUCCESS,
  REMOVE_CONVERSATION_ADMIN_LOADING,
  REMOVE_CONVERSATION_ADMIN_SUCCESS,
  INVITE_USER_CONVERSATION_SUCCESS,
  REMOVE_CONVERSATION_PARTICIPANT_LOADING,
  REMOVE_CONVERSATION_PARTICIPANT_SUCCESS,
  DELETE_CONVERSATION_LOADING,
  DELETE_CONVERSATION_FROM_EVENT_STREAM,
} from "~/store/action_types";

const conversation = (state = Map(), action) => {
  switch (action.type) {
    case ADD_CONVERSATION_SUCCESS:
    case INVITE_USER_CONVERSATION_SUCCESS:
    case ADD_CONVERSATION_FROM_EVENT_STREAM:
    case EDIT_CONVERSATION_FROM_EVENT_STREAM:
    case ADD_CONVERSATION_ADMIN_SUCCESS:
    case REMOVE_CONVERSATION_ADMIN_SUCCESS:
    case REMOVE_CONVERSATION_PARTICIPANT_SUCCESS:
    case FETCH_CONVERSATION_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { single: id } = result;
      const { conversations } = entities;

      const values = conversations[id];

      if (values) {
        return fromJS(values);
      }

      return state;
    }
    case EDIT_CONVERSATION_LOADING: {
      const { attributes } = action;
      return state.merge(fromJS(attributes));
    }
    case DELETE_CONVERSATION_USER_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { user_conversations: userConversations } = entities;
      const { single: conversationId } = result;

      const data = userConversations && userConversations[conversationId];

      if (data) {
        const members = state.get("members", List()).filter((memberId) => memberId !== data?.user_id);
        const admins = state.get("admins", List()).filter((adminId) => adminId !== data?.user_id);

        return state.merge(
          fromJS({
            members,
            admins,
          })
        );
      }

      return state;
    }
    case ADD_CONVERSATION_ADMIN_LOADING: {
      const { userId = 0 } = action;
      const admins = state.get("admins", List());
      if (userId > 0 && !admins.includes(userId)) {
        return state.merge(
          Map({
            admins: admins.push(userId),
          })
        );
      }
      return state;
    }
    case REMOVE_CONVERSATION_ADMIN_LOADING: {
      const { userId = 0 } = action;
      const admins = state.get("admins", List());
      if (userId > 0 && admins.includes(userId)) {
        return state.merge(
          Map({
            admins: admins.filter((id) => id !== userId),
          })
        );
      }
      return state;
    }
    case REMOVE_CONVERSATION_PARTICIPANT_LOADING: {
      const { userId = 0 } = action;
      const members = state.get("members", List());
      if (userId > 0 && members.includes(userId)) {
        return state.merge(
          Map({
            members: members.filter((id) => id !== userId),
          })
        );
      }
      return state;
    }
    default:
      return state;
  }
};

const conversations = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_CONVERSATIONS_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { conversations } = entities;
      return state.merge(fromJS(conversations));
    }
    case ADD_CONVERSATION_SUCCESS:
    case ADD_CONVERSATION_FROM_EVENT_STREAM:
    case EDIT_CONVERSATION_FROM_EVENT_STREAM:
    case INVITE_USER_CONVERSATION_SUCCESS:
    case ADD_CONVERSATION_ADMIN_SUCCESS:
    case REMOVE_CONVERSATION_ADMIN_SUCCESS:
    case REMOVE_CONVERSATION_PARTICIPANT_SUCCESS:
    case FETCH_CONVERSATION_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { single: id } = result;
      if (id) {
        return state.set(`${id}`, conversation(state.get(`${id}`), action));
      }
      return state;
    }
    case EDIT_CONVERSATION_LOADING: {
      const { id } = action;
      return state.set(`${id}`, conversation(state.get(`${id}`), action));
    }
    case DELETE_CONVERSATION_LOADING:
    case DELETE_CONVERSATION_FROM_EVENT_STREAM:
    case LEAVE_CONVERSATION_LOADING: {
      const { id = 0 } = action;
      if (id > 0) {
        return state.remove(`${id}`);
      }
      return state;
    }
    case DELETE_CONVERSATION_USER_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { single: conversationId } = result;

      if (conversationId > 0) {
        return state.set(`${conversationId}`, conversation(state.get(`${conversationId}`), action));
      }
      return state;
    }
    case ADD_CONVERSATION_ADMIN_LOADING:
    case REMOVE_CONVERSATION_PARTICIPANT_LOADING:
    case REMOVE_CONVERSATION_ADMIN_LOADING: {
      const { id = 0 } = action;
      if (id > 0) {
        return state.set(`${id}`, conversation(state.get(`${id}`), action));
      }
      return state;
    }
    default:
      return state;
  }
};

export default conversations;
